import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ca6f37b")

_pushScopeId("data-v-3ca6f37b")
const _hoisted_1 = { class: "modal bg_white page_padding" }
const _hoisted_2 = { class: "modal_header" }
const _hoisted_3 = { class: "modal_body mt-5" }
const _hoisted_4 = { class: "modal_footer mt-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_form_field, {
        class: "little",
        type: "text",
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
        placeholderKey: "backoffice_Cerca",
        placeholderValue: "Cerca"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredList, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["selection_div", {selected : item.identifier == _ctx.identifierSelected}],
          key: item.identifier + item.text + index,
          onClick: ($event: any) => (_ctx.select(item.identifier))
        }, [
          _createVNode("span", {
            class: "fev_text5 fw_600",
            innerHTML: item.text
          }, null, 8, ["innerHTML"])
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        class: "fev_button bg_brand",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select(_ctx.identifierSelected))),
        disabled: _ctx.isDisabled
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_Conferma",
          text: "Conferma"
        })
      ], 8, ["disabled"])
    ])
  ]))
})